import { RbacFeature, RbacFeatureDetails, RbacApiPermission } from '@evidentid/tprm-portal-lib/models/rbac';

type ConfigurationFeatures = Extract<RbacFeature,
    | RbacFeature.configurationActivityHistory
    | RbacFeature.configurationApiSettings
    | RbacFeature.configurationCustomProperties
    | RbacFeature.configurationUsersAndRoles
    | RbacFeature.configurationGoAppSettings
>;

export const CONFIGURATION_FEATURE_PERMISSIONS_MAP: Record<ConfigurationFeatures, RbacFeatureDetails> = {
    [RbacFeature.configurationActivityHistory]: {
        name: RbacFeature.configurationActivityHistory,
        label: 'View platform activity history',
        requiredPermissions: [ RbacApiPermission.configGetActivityHistory ],
    },
    [RbacFeature.configurationApiSettings]: {
        name: RbacFeature.configurationApiSettings,
        label: 'View and edit API settings',
        requiredPermissions: [
            RbacApiPermission.configGetApiKey,
            RbacApiPermission.configGetWebhooks,
            RbacApiPermission.configPostWebhook,
            RbacApiPermission.configPostWebhook,
            RbacApiPermission.configPatchWebhook,
        ],
    },
    [RbacFeature.configurationCustomProperties]: {
        name: RbacFeature.configurationCustomProperties,
        label: 'Manage custom properties',
        requiredPermissions: [
            RbacApiPermission.configGetCustomProperties,
            RbacApiPermission.configPostCustomProperty,
            RbacApiPermission.configPatchCustomProperty,
        ],
    },
    [RbacFeature.configurationUsersAndRoles]: {
        name: RbacFeature.configurationUsersAndRoles,
        label: 'View and edit users and roles',
        requiredPermissions: [
            RbacApiPermission.usersGet,
            RbacApiPermission.userPost,
            RbacApiPermission.userPut,
            RbacApiPermission.userDelete,
            RbacApiPermission.userPostResendInvite,
        ],
    },
    [RbacFeature.configurationGoAppSettings]: {
        name: RbacFeature.configurationGoAppSettings,
        label: 'View and edit Go App settings',
        requiredPermissions: [
            RbacApiPermission.configGetRpSettings,
            RbacApiPermission.configPutRpSettings,
            // The settings page cannot work without the custom properties list.
            RbacApiPermission.configGetCustomProperties,
        ],
    },
};
